import { render, staticRenderFns } from "./slides-item.vue?vue&type=template&id=31e519b0&scoped=true&"
import script from "./slides-item.vue?vue&type=script&lang=js&"
export * from "./slides-item.vue?vue&type=script&lang=js&"
import style0 from "./slides-item.vue?vue&type=style&index=0&id=31e519b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e519b0",
  null
  
)

export default component.exports